import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";
import "new_components/ContactUs/ContactUs.scss";
import "new_assets/fonts/fonts.css";
import "new_assets/css/styles.css";
import Header from "new_components/Header/Header";
import Footer from "new_components/Footer/Footer";
import ProgressCircle from "new_components/ScrollProgress/ScrollProgress";
import ScrollToTopDefault from "components/Layouts/LayoutPrimary/ScrollToTopDefault";
import apiUrls, { Image_Base_URL } from "new_components/BaseApi/BaseApi.js";
import PreLoad from "new_components/PreLoad/PreLoad";

function ContactUs() {
  return (
    <>
      <ScrollToTopDefault />
      <Header />
      <ProgressCircle />
      <Body />
      <Footer />
    </>
  );
}

function Body() {
  const [selectedForm, setSelectedForm] = useState("form1");
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(apiUrls.contactCms) // Replace with the actual API endpoint
      .then((response) => {
        setData(response.data);
      })
      .catch((err) => {
        setError("Failed to load contact information. Please try again later.");
      });
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const formParam = params.get("form");
    if (formParam && ["form1", "form2", "form3"].includes(formParam)) {
      setSelectedForm(formParam);
    } else {
      setSelectedForm("form1");
    }
  }, [location.search]);

  const handleRadioChange = (value) => {
    setSelectedForm(value);
    navigate(`?form=${value}`);
  };

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  if (!data) {
    return (
      <div className="loading-message">
        <PreLoad />
      </div>
    );
  }

  return (
    <div>
      <section className="flat-section">
        <div className="container">
          <div
            className="row align-items-center justify-content-center wow fadeInUp contactusbanner mx-md-5"
            style={{
              backgroundImage: `url(${Image_Base_URL}${data.image1})`,
            }}
            data-wow-delay=".2s"
          >
            <div className="col-12 text-center">
              <h3 className="title text-white text-uppercase">{data.title}</h3>
            </div>
          </div>
        </div>
      </section>
      <section className="flat-section flat-contact contactus-body pb-0">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 pb-2 pb-md-0">
              <h4 className="mb-1 text-uppercase">{data.sub_title}</h4>
              <div className="body-2">{data.content}</div>
              <div className="container mt-3 contactform">
                <form className="d-flex justify-content-start row px-4">
                  {["form1", "form2", "form3"].map((form, index) => (
                    <div className="form-check col-6 col-md-4" key={form}>
                      <input
                        className="form-check-input"
                        type="radio"
                        name="forms"
                        id={form}
                        value={form}
                        checked={selectedForm === form}
                        onChange={() => handleRadioChange(form)}
                      />
                      <label className="form-check-label note body-2" htmlFor={form}>
                        {data[`rdobtn${index + 1}`]}
                      </label>
                    </div>
                  ))}
                </form>
                <div
                  className="my-4"
                  style={{
                    position: "relative",
                    width: "100%",
                    height: "100vh",
                    // border: "1px solid #ccc",
                    // overflow:"auto",
                  }}
                >
                  <iframe
                    // key={selectedForm}
                    src={
                      selectedForm === "form1"
                        ? data.formUrlInv
                        : selectedForm === "form2"
                        ? data.formUrlVen
                        : data.formUrlGenEnq
                    }
                    style={{
                      // position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                    }}
                  ></iframe>
                </div>
              </div>
            </div>

            <div className="col-lg-4 pb-4">
              <div className="contact-info">
                <div dangerouslySetInnerHTML={{ __html: data.contactInfo }} />
                <li className="box">
                  <ul className="box-social">
                    {data.linkedin && (
                      <li>
                        <a href={data.linkedin} target="_blank" rel="noreferrer" className="item">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M3.58151 16H0.264292V5.31762H3.58151V16ZM1.92111 3.86044C0.860376 3.86044 0 2.98185 0 1.92111C7.59231e-09 1.4116 0.202403 0.92296 0.562681 0.562681C0.92296 0.202403 1.4116 0 1.92111 0C2.43063 0 2.91927 0.202403 3.27955 0.562681C3.63983 0.92296 3.84223 1.4116 3.84223 1.92111C3.84223 2.98185 2.98149 3.86044 1.92111 3.86044ZM15.9968 16H12.6867V10.7999C12.6867 9.56057 12.6617 7.97125 10.962 7.97125C9.23735 7.97125 8.97306 9.31771 8.97306 10.7106V16H5.65941V5.31762H8.84091V6.77479H8.88734C9.33021 5.93549 10.412 5.04976 12.026 5.04976C15.3832 5.04976 16.0004 7.26052 16.0004 10.132V16H15.9968Z"
                              fill="black"
                            />
                          </svg>
                        </a>
                      </li>
                    )}

                    {data.pinterest && (
                      <li>
                        <a href={data.pinterest} target="_blank" rel="noreferrer" className="item">
                          <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M7.35713 0C3.65693 0 0 2.4668 0 6.45913C0 8.99806 1.42815 10.4406 2.29369 10.4406C2.65073 10.4406 2.8563 9.44526 2.8563 9.16395C2.8563 8.82856 2.00157 8.11448 2.00157 6.71879C2.00157 3.81922 4.20871 1.76355 7.06501 1.76355C9.52099 1.76355 11.3386 3.15924 11.3386 5.72341C11.3386 7.63843 10.5705 11.2304 8.08202 11.2304C7.18402 11.2304 6.41585 10.5813 6.41585 9.65082C6.41585 8.28759 7.36795 6.96763 7.36795 5.56112C7.36795 3.17366 3.9815 3.60644 3.9815 6.49158C3.9815 7.09747 4.05724 7.76826 4.32772 8.32005C3.83003 10.4623 2.81302 13.654 2.81302 15.8611C2.81302 16.5427 2.91039 17.2135 2.97531 17.8951C3.09793 18.0322 3.03662 18.0178 3.22415 17.9492C5.0418 15.4608 4.97688 14.9739 5.79915 11.7173C6.24274 12.5612 7.38959 13.0156 8.29841 13.0156C12.1284 13.0156 13.8487 9.28297 13.8487 5.91816C13.8487 2.33697 10.7544 0 7.35713 0Z"
                              fill="#161E2D"
                            />
                          </svg>
                        </a>
                      </li>
                    )}

                    {data.facebook && (
                      <li>
                        <a href={data.facebook} target="_blank" rel="noreferrer" className="item">
                          <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M9.00879 10.125L9.50871 6.86742H6.38297V4.75348C6.38297 3.86227 6.81961 2.99355 8.21953 2.99355H9.64055V0.220078C9.64055 0.220078 8.35102 0 7.11809 0C4.54395 0 2.86137 1.56023 2.86137 4.38469V6.86742H0V10.125H2.86137V18H6.38297V10.125H9.00879Z"
                              fill="#161E2D"
                            />
                          </svg>
                        </a>
                      </li>
                    )}

                    {data.youtube && (
                      <li>
                        <a href={data.youtube} target="_blank" rel="noreferrer" className="item">
                          <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M19.2775 2.16608C19.051 1.31346 18.3839 0.641967 17.5368 0.414086C16.0013 0 9.84445 0 9.84445 0C9.84445 0 3.68759 0 2.15212 0.414086C1.30502 0.642003 0.637857 1.31346 0.411419 2.16608C0 3.71149 0 6.93586 0 6.93586C0 6.93586 0 10.1602 0.411419 11.7056C0.637857 12.5583 1.30502 13.2018 2.15212 13.4296C3.68759 13.8437 9.84445 13.8437 9.84445 13.8437C9.84445 13.8437 16.0013 13.8437 17.5368 13.4296C18.3839 13.2018 19.051 12.5583 19.2775 11.7056C19.6889 10.1602 19.6889 6.93586 19.6889 6.93586C19.6889 6.93586 19.6889 3.71149 19.2775 2.16608ZM7.8308 9.86334V4.00837L12.9767 6.93593L7.8308 9.86334Z"
                              fill="#161E2D"
                            />
                          </svg>
                        </a>
                      </li>
                    )}

                    {data.instagram && (
                      <li>
                        <a href={data.instagram} target="_blank" rel="noreferrer" className="item">
                          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M9.00245 4.38427C6.4484 4.38427 4.38828 6.44438 4.38828 8.99844C4.38828 11.5525 6.4484 13.6126 9.00245 13.6126C11.5565 13.6126 13.6166 11.5525 13.6166 8.99844C13.6166 6.44438 11.5565 4.38427 9.00245 4.38427ZM9.00245 11.9983C7.35195 11.9983 6.00264 10.653 6.00264 8.99844C6.00264 7.34392 7.34794 5.99862 9.00245 5.99862C10.657 5.99862 12.0023 7.34392 12.0023 8.99844C12.0023 10.653 10.653 11.9983 9.00245 11.9983ZM14.8816 4.19552C14.8816 4.79388 14.3997 5.27176 13.8054 5.27176C13.207 5.27176 12.7291 4.78986 12.7291 4.19552C12.7291 3.60118 13.211 3.11928 13.8054 3.11928C14.3997 3.11928 14.8816 3.60118 14.8816 4.19552ZM17.9376 5.28782C17.8694 3.84615 17.5401 2.56912 16.4839 1.51697C15.4318 0.46483 14.1547 0.135534 12.7131 0.0632491C11.2272 -0.021083 6.77368 -0.021083 5.28782 0.0632491C3.85016 0.131518 2.57313 0.460815 1.51697 1.51296C0.460815 2.5651 0.135534 3.84213 0.0632491 5.28381C-0.021083 6.76966 -0.021083 11.2232 0.0632491 12.7091C0.131518 14.1507 0.460815 15.4278 1.51697 16.4799C2.57313 17.532 3.84615 17.8613 5.28782 17.9336C6.77368 18.018 11.2272 18.018 12.7131 17.9336C14.1547 17.8654 15.4318 17.5361 16.4839 16.4799C17.5361 15.4278 17.8654 14.1507 17.9376 12.7091C18.022 11.2232 18.022 6.77368 17.9376 5.28782ZM16.0181 14.3033C15.7048 15.0904 15.0985 15.6968 14.3073 16.0141C13.1227 16.4839 10.3116 16.3755 9.00245 16.3755C7.6933 16.3755 4.87821 16.4799 3.69756 16.0141C2.91046 15.7008 2.30407 15.0944 1.98682 14.3033C1.51697 13.1187 1.6254 10.3076 1.6254 8.99844C1.6254 7.68928 1.52099 4.8742 1.98682 3.69355C2.30006 2.90645 2.90645 2.30006 3.69756 1.98281C4.88223 1.51296 7.6933 1.62139 9.00245 1.62139C10.3116 1.62139 13.1267 1.51697 14.3073 1.98281C15.0944 2.29604 15.7008 2.90243 16.0181 3.69355C16.4879 4.87821 16.3795 7.68928 16.3795 8.99844C16.3795 10.3076 16.4879 13.1227 16.0181 14.3033Z"
                              fill="#161E2D"
                            />
                          </svg>
                        </a>
                      </li>
                    )}

                    {data.x && (
                      <li>
                        <a href={data.x} target="_blank" rel="noreferrer" className="item">
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M8.30314 5.92804L13.4029 0H12.1944L7.7663 5.14724L4.22958 0H0.150391L5.4986 7.78354L0.150391 14H1.35894L6.03514 8.56434L9.77017 14H13.8494L8.30284 5.92804H8.30314ZM6.64787 7.85211L6.10598 7.07705L1.79439 0.909771H3.65065L7.13015 5.88696L7.67204 6.66202L12.195 13.1316H10.3387L6.64787 7.85241V7.85211Z"
                              fill="#161E2D"
                            />
                          </svg>
                        </a>
                      </li>
                    )}
                  </ul>
                </li>

                <li className="box">
                  {selectedForm !== "form2" && selectedForm !== "form3" && (
                    <>
                      <h6 className="title">Already have a CashFlow account?</h6>
                      <button className="btn btn-primary">
                        <Link to={data.cashflow_login_link} className="text-white" target="_blank" rel="noopener noreferrer">
                          Login
                        </Link>
                      </button>
                    </>
                  )}
                </li>
              </div>

              <div className="support-card mt-5">
                <p className="body-2 text-white pb-2">{data.cont_to_exp_title}</p>

                <a href={data.cont_to_exp_url1} target="_blank">
                  <h6 className="support-link pt-2">{data.cont_to_exp_heading1}</h6>
                </a>

                <a href={data.cont_to_exp_url2} target="_blank" className="support-link pt-2">
                  <h6 className="support-link"> {data.cont_to_exp_heading2}</h6>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ContactUs;
